module.exports = __webpack_public_path__ + "static/media/lamina16fondo.4099f3e5.png";